module.exports = __webpack_public_path__ + "img/view-list.fed42e4d.svg";